import React from 'react';

import './ListField.scss';
import Icon from 'Core/Components/Icon';
import { handleError } from 'RLX/State/Ui/UiActions';

class ListField extends React.Component {
  constructor (props) {
    super(props);
    this.handleItemAdd = this.handleItemAdd.bind(this);
    this.onItemDelete = this.onItemDelete.bind(this);
    this.onItemUpdate = this.onItemUpdate.bind(this);
    this.onItemReorder = this.onItemReorder.bind(this);
    this.renderEmptyState = this.renderEmptyState.bind(this);
    this.shouldPromptBeforeDeleting = this.shouldPromptBeforeDeleting.bind(this);
  }

  getClassName () {
    return null;
  }

  shouldPromptBeforeDeleting (item) {
    return true;
  }

  onItemDelete (targetIndex) {
    const { value, onChange } = this.props;
    const shouldPrompt = this.shouldPromptBeforeDeleting(value[targetIndex]);
    if (typeof onChange !== 'function' || typeof targetIndex !== 'number' || !value) return;
    if (!shouldPrompt || confirm(`Are you sure you wish to delete this item?`)) {
      const newValue = value.filter((item, index) => index !== targetIndex);
      return onChange(newValue);
    }
  }

  onItemUpdate (newItem, targetIndex) {
    const { value, onChange } = this.props;
    if (typeof onChange !== 'function' || !value) return;
    const newValue = value.map((item, index) => index === targetIndex ? newItem : item);
    onChange(newValue);
  }


  renderEmptyState () {
    return null;
  }

  renderListItem (item, index) {
    return (
      <div className="ListField-DefaultRenderer" key={index}>
        <h5>Item {index + 1}</h5>
        <pre style={{ whiteSpace: 'normal' }}><code>{JSON.stringify(item, null, '  ')}</code></pre>
      </div>
    );
  }

  onItemReorder (index, direction) {
    const { value, onChange } = this.props;
    if (typeof index !== 'number')
      throw new TypeError(`ListField.handleItemReorder: index is not a number (${index})`);
    if (typeof direction !== 'string')
      throw new TypeError(`ListField.handleItemReorder: direction is not a string (${direction})`);
    if (!Array.isArray(value))
      throw new TypeError(`ListField.handleItemReorder: props.value is not an array (${value})`);
    if (typeof onChange !== 'function')
      throw new TypeError(`ListField.handleItemReorder: onChange is not a function (${onChange})`);

    const item = value[index];
    const listWithoutItem = value.filter((listItem, itemIndex) => itemIndex !== index);

    switch (direction) {
      case 'start':
        return onChange([ item, ...listWithoutItem ]);
      case 'prev':
        listWithoutItem.splice(index - 1, 0, item);
        return onChange([ ...listWithoutItem ])
      case 'next':
        listWithoutItem.splice(index + 1, 0, item);
        return onChange([ ...listWithoutItem ]);
      case 'end':
        return onChange([ ...listWithoutItem, item ]);
      default: return;
    };
  }

  handleItemAdd () {
    let { value, onChange } = this.props;
    if (typeof onChange !== 'function')
      throw new TypeError('ListField.handleItemAdd: onChange is not a function');
    if (typeof value !== 'undefined' && !Array.isArray(value)) {
      handleError('Error: Can\'t add an item: value given is not array (check console).');
      console.warn('Nonarray ListFieldValue:', value);
      return;
    }
    value = !value ? [] : value;
    const blankItem = this.getItemDefaults();
    const newValue = [ ...value, blankItem ];
    onChange(newValue);
  }

  getItemDefaults () {
    return null;
  }

  render () {
    const { value, icon, label } = this.props;
    const { renderListItem, renderEmptyState, handleItemAdd } = this;
    const allowItemAdd = this.getItemDefaults() !== null;
    const className = this.getClassName();

    return (
      <div className={'ListField' + (className ? ' ' + className : '')}>
        <div className="ListField-Header">
          <label>
            {!icon ? null : <Icon fa={icon}/>}
            {!label ? null : label}
          </label>
          <box>
            {!allowItemAdd ? null : (
              <a onClick={handleItemAdd} title="Add An Item To This List">
                <Icon fa={'plus-circle'}/>
              </a>
            )}
          </box>
        </div>
        <div className="ListField-Content">
          {!value || !value.length
            ? renderEmptyState()
            : value.map((itemValue, itemIndex) => renderListItem(itemValue, itemIndex, value.length))
          }
          <div className="ListField-AddPanel" onClick={handleItemAdd}>
            <Icon fa="plus-square"/>
          </div>
        </div>
      </div>
    );
  }
};

export default ListField;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ListField/ListField.jsx